import { GelTheme } from 'components/GelTheme';
import { PropsWithChildren } from 'react';
import { Modal } from '@snsw/react-component-library';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: ${GelTheme.spacing(0.5)};
`;

interface ModalAlertProps {
  title?: string;
  onClose: () => void;
}

export const ModalAlert = ({ title, children, onClose }: PropsWithChildren<ModalAlertProps>) => {
  return (
    <Modal
      title={title ?? ''}
      onClose={onClose}
      buttons={[
        {
          text: 'Close',
          onClick: onClose,
        },
      ]}
    >
      <Container>{children}</Container>
    </Modal>
  );
};
